
import { eplStyles } from "../clientstyles/commonstyles";
import { applyAcceptToEditor, cleanupItem } from './SuggestionAction';
import "./AutoSuggestion.css"
import { epl } from "../clientstyles/epl";
import { edp } from "../clientstyles/edp";
import { PeToolsStyles } from "../clientstyles/PeToolStyles";
import { CeToolStyles } from "../clientstyles/CeToolStyles";
import React from "react";
import { createRoot } from 'react-dom/client';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';
import { PopupDiff } from "./PopupDiff";
export let globalAnchorList = [];
export function addToGlobalAnchorList(item) {
    globalAnchorList.push(item);
}
export function clearallglobalanchorlist() {
    globalAnchorList = [];
    globalRejectedAnchorList = [];
}
console.log("all the states are in the globalanchorlist is:", globalAnchorList);
let globalRejectedAnchorList = [];
let globalPropsRef = null;
let activeStyles = [];
let globalRejectedRef = null;
export let globalRejectedIds = new Set();
let globalRejectedPositions = [];
let globalRejectedKeys = new Set();

export function getPositionFromIndex(text, startIndex, length) {
    let row = 0, col = 0;
    for (let i = 0; i < startIndex; i++) {
        if (text[i] === '\n') { row++; col = 0; } else col++;
    }
    const startRow = row, startCol = col;
    for (let i = startIndex; i < startIndex + length; i++) {
        if (text[i] === '\n') { row++; col = 0; } else col++;
    }
    return { startRow, startCol, endRow: row, endCol: col };
}

export const forceClearAllWithDOMCleanup = (editor) => {
    const session = editor.session;
    const frontMarkers = session.getMarkers(true);
    const backMarkers = session.getMarkers(false);

    [...Object.keys(frontMarkers), ...Object.keys(backMarkers)].forEach(id => {
        session.removeMarker(parseInt(id));
    });
    globalAnchorList.forEach(item => {
        if (item.startAnchor?.detach) item.startAnchor.detach();
        if (item.endAnchor?.detach) item.endAnchor.detach();
        item.markerId = null;
    });
    globalAnchorList = [];
    const container = editor.container;
    const markerLayers = container.querySelectorAll('.ace_layer.ace_marker-layer');
    markerLayers.forEach(layer => {
        const markerSpans = layer.querySelectorAll(
            '[class*="ace-Common"], [class*="ace-EPL"], [class*="ace-EDP"], [class*="ace-highlight"],[class*="ace-Common-highlight"]'
        );
        markerSpans.forEach(span => span.remove());
    });
    session._signal("changeBackMarker");
    session._signal("changeFrontMarker");
    editor.renderer.updateFull(true);
};

export function createAnchor(
    session, Range, position,
    originalText, suggestionText,
    markerClass, styleName, description,
    anchorlist, extraStyleInfo = {}
) {
    const id = `${styleName}__${crypto.randomUUID()}`;

    const startAnchor = session.doc.createAnchor(position.startRow, position.startCol);
    const endAnchor = session.doc.createAnchor(position.endRow, position.endCol);
    startAnchor.$insertRight = false;
    endAnchor.$insertRight = true;

    const range = new Range(position.startRow, position.startCol, position.endRow, position.endCol);
    const markerId = session.addMarker(range, markerClass, "text");

    anchorlist.push({
        id,
        startAnchor,
        endAnchor,
        markerId,
        originalText,
        suggestionText,
        range,
        styleInfo: { name: styleName, description, ...extraStyleInfo },
        extraStyleInfo
    });
}

export function cleanupAnchor(session, item) {
    console.log("cleanupAnchor called for:", item.originalText, "markerId:", item.markerId);
    if (item.markerId) session.removeMarker(item.markerId);
    if (item.startAnchor?.detach) item.startAnchor.detach();
    if (item.endAnchor?.detach) item.endAnchor.detach();
}

export function removeFromGlobalAnchorList(item) {
    const i = globalAnchorList.indexOf(item);
    if (i > -1) globalAnchorList.splice(i, 1);
}

export function isAlreadyAnchored(position, styleName, existingSuggestions) {
    return existingSuggestions.some(ex =>
        ex.styleInfo.name === styleName &&
        ex.startAnchor.row === position.startRow &&
        ex.startAnchor.column === position.startCol &&
        ex.endAnchor.column === position.endCol &&
        ex.endAnchor.row === position.endRow
    );
}

export function getOverlappingAnchors(position, styleName, existingSuggestions) {
    return existingSuggestions.filter(ex =>
        ex.styleInfo.name === styleName &&
        ex.startAnchor.row === position.startRow &&
        (
            ex.startAnchor.column === position.startCol ||
            (ex.startAnchor.column >= position.startCol && ex.startAnchor.column < position.endCol) ||
            (ex.endAnchor.column > position.startCol && ex.endAnchor.column <= position.endCol)
        )
    );
}

export function isRejectedByLivePosition(position, styleName, originalText) {
    return globalRejectedAnchorList.some(item =>
        item.styleInfo?.name === styleName &&
        item.originalText === originalText &&
        item.startAnchor.row === position.startRow &&
        item.startAnchor.column === position.startCol
    );
}

// function findDeletedAnchors(texFile, existingSuggestions) {
//     const deletedIds = new Set();
//     const lines = texFile.split('\n');

//     existingSuggestions.forEach(item => {
//         const row = item.startAnchor.row;
//         const col = item.startAnchor.column;
//         const line = lines[row];

//         if (line === undefined) {
//             deletedIds.add(item.id);
//             return;
//         }
//         const textAtPosition = line.substring(col, col + item.originalText.length);
//         if (textAtPosition !== item.originalText) {
//             deletedIds.add(item.id);
//         }
//     });

//     return deletedIds;
// }
function findDeletedAnchors(texFile, existingSuggestions) {
    const deletedIds = new Set();
    const lines = texFile.split('\n');

    existingSuggestions.forEach(item => {
        // Query-only anchors have no originalText — skip text-match check.
        // Their lifecycle is managed entirely by the style's staleIds return.
        if (item.queryOnly || item.originalText == null) return;

        const row = item.startAnchor.row;
        const col = item.startAnchor.column;
        const line = lines[row];

        if (line === undefined) {
            deletedIds.add(item.id);
            return;
        }
        const textAtPosition = line.substring(col, col + item.originalText.length);
        if (textAtPosition !== item.originalText) {
            deletedIds.add(item.id);
        }
    });

    return deletedIds;
}

export function acceptItem(editor, item, setTextFile, props, setAllFiles = null) {
    try {
        const liveItem = globalAnchorList.find(a => a.id === item.id) || item;
        applyAcceptToEditor(editor, liveItem, setTextFile, setAllFiles, props);
        cleanupAnchor(editor.session, liveItem);
        removeFromGlobalAnchorList(liveItem);
        props?.removeAutoSuggestion(liveItem);
    } catch (err) {
        console.error("Accept error:", err);
    }
}

export function rejectItem(editor, item, props) {
    try {
        const liveItem = globalAnchorList.find(a => a.id === item.id) || item;

        if (liveItem.markerId) editor.session.removeMarker(liveItem.markerId);
        if (liveItem.endAnchor?.detach) liveItem.endAnchor.detach();

        liveItem.markerId = null;
        liveItem.rejected = true;

        removeFromGlobalAnchorList(liveItem);
        globalRejectedAnchorList.push(liveItem);

        const rejectedEntry = {
            id: liveItem.id,
            originalText: liveItem.originalText,
            styleName: liveItem.styleInfo?.name,
            anchorRef: liveItem.startAnchor
        };

        globalRejectedKeys.add(liveItem.id);

        if (globalRejectedRef) {
            globalRejectedRef = [...globalRejectedRef, rejectedEntry];
        } else {
            globalRejectedRef = [rejectedEntry];
        }

        props?.addAutoSuggestionReject({
            id: liveItem.id,
            originalText: liveItem.originalText,
            styleName: liveItem.styleInfo?.name
        });
        props?.removeAutoSuggestion(liveItem);
    } catch (err) {
        console.error("Reject error:", err);
    }
}

export function rejectAll() {
    globalRejectedAnchorList = [];
}
function acceptSuggestion(editor, item, setTextFile, props) {
    acceptItem(editor, item, setTextFile, props);
}

function rejectSuggestion(item, props, editor) {
    rejectItem(editor, item, props);
}

function removePopup() {
    const existing = document.getElementById('ace-suggestion-popup');
    if (existing) existing.remove();
}

// ── Helper: clean up any anchors placed so far in a cancelled run ──
function cancelRunCleanup(newAnchorList, session, props) {
    newAnchorList.forEach(item => {
        if (item.markerId) session.removeMarker(item.markerId);
        if (item.startAnchor?.detach) item.startAnchor.detach();
        if (item.endAnchor?.detach) item.endAnchor.detach();
    });
    props.StopLoading();
}

// export async function AutoSuggestion(
//     texFile, ace, selectedStyles = [], client,
//     props, setTextFile, fileName, Allfiles,
//     generation = null,    // ← cancellation token
//     generationRef = null  // ← ref to latest generation counter
// ) {
//     // ── isCancelled: true if a newer keystroke has fired since this run started ──
//     const isCancelled = () =>
//         generation !== null &&
//         generationRef !== null &&
//         generation !== generationRef.current;

//     if (!props.showSuggestion) {
//         globalPropsRef = null;
//         return;
//     }

//     const styleRegistry = {
//         epl: epl,
//         edp: edp,
//         common: { ...eplStyles, ...epl, ...edp },
//         PeToolsStyles: PeToolsStyles,
//         CeToolStyles: CeToolStyles
//     };

//     globalPropsRef = props.autoSuggestions;
//     props.startLoading();
//     globalRejectedRef = props.autoSuggestionsRejected || [];
//     console.log("the client and the styles in autosuggestion is :", client, "the styles are", selectedStyles);

//     if (props.view === "suggestions") {
//         if (!ace?.current) { props.StopLoading(); return null; }

//         const styleSource = styleRegistry[client] || styleRegistry.common;

//         activeStyles = selectedStyles
//             .map(name => styleSource[name])
//             .filter(Boolean);
//         if (activeStyles.length === 0) {
//             props.StopLoading();
//             return [];
//         }
//         try {
//             const editor = ace.current.editor;
//             const session = editor.session;
//             const Range = window.ace.require('ace/range').Range;

//             // ── Async gap: check immediately after ──
//             await new Promise(r => setTimeout(r, 100));
//             if (isCancelled()) {
//                 props.StopLoading();
//                 return [];
//             }

//             removePopup();

//             const existingSuggestions = props.autoSuggestions || [];
//             const rejectedSuggestions = props.autoSuggestionsRejected || [];
//             const newAnchorList = [];
//             const allStaleIds = new Set();

//             // ── Run each style with cancellation check before AND after each one ──
//             for (const style of activeStyles) {

//                 // ── CHECK BEFORE: bail before even starting this style ──
//                 if (isCancelled()) {
//                     console.log(`AutoSuggestion cancelled before style "${style?.name}" — discarding ${newAnchorList.length} partial anchors`);
//                     cancelRunCleanup(newAnchorList, session, props);
//                     return [];
//                 }

//                 if (typeof style.execute !== 'function') continue;

//                 try {
//                     const result = style.execute(
//                         texFile, session, Range, newAnchorList,
//                         fileName, Allfiles,
//                         existingSuggestions,
//                         rejectedSuggestions
//                     );
//                     const returned = (result instanceof Promise) ? await result : result;

//                     // ── CHECK AFTER: async styles may have taken long enough for a new keystroke ──
//                     if (isCancelled()) {
//                         console.log(`AutoSuggestion cancelled after style "${style?.name}" — discarding ${newAnchorList.length} partial anchors`);
//                         cancelRunCleanup(newAnchorList, session, props);
//                         return [];
//                     }

//                     if (returned instanceof Set) {
//                         returned.forEach(id => allStaleIds.add(id));
//                     }
//                 } catch (err) {
//                     console.error(`Style "${style.name}" error:`, err);
//                 }
//             }

//             // ── Final check before committing anything visible to the editor ──
//             if (isCancelled()) {
//                 console.log(`AutoSuggestion cancelled before commit — discarding ${newAnchorList.length} anchors`);
//                 cancelRunCleanup(newAnchorList, session, props);
//                 return [];
//             }

//             // ── Find and clean up deleted/stale anchors ──
//             const deletedIds = findDeletedAnchors(texFile, existingSuggestions);
//             deletedIds.forEach(id => allStaleIds.add(id));
//             cleanupStaleRejectedAnchors(texFile);

//             if (allStaleIds.size > 0) {
//                 existingSuggestions
//                     .filter(item => allStaleIds.has(item.id))
//                     .forEach(item => cleanupAnchor(session, item));
//                 props.removeStaleAutoSuggestions([...allStaleIds]);
//             }

//             // ── Auto apply mode ──
//             if (!props.showIsChecked && props.autoapply) {
//                 let temp = texFile;

//                 for (const style of activeStyles) {

//                     // ── Cancellation inside autoapply loop ──
//                     if (isCancelled()) {
//                         props.StopLoading();
//                         return [];
//                     }

//                     if (typeof style.execute !== 'function') continue;

//                     try {
//                         const matchList = [];

//                         const fakeDoc = {
//                             createAnchor: (row, col) => ({
//                                 row,
//                                 column: col,
//                                 $insertRight: false,
//                                 detach: () => { }
//                             })
//                         };
//                         const fakeSession = {
//                             doc: fakeDoc,
//                             addMarker: () => null,
//                             removeMarker: () => { },
//                             getLine: (row) => temp.split('\n')[row] || ''
//                         };
//                         const FakeRange = function (sr, sc, er, ec) {
//                             return { start: { row: sr, column: sc }, end: { row: er, column: ec } };
//                         };

//                         const result = style.execute(
//                             temp, fakeSession, FakeRange, matchList,
//                             fileName, Allfiles, [], []
//                         );
//                         if (result instanceof Promise) await result;

//                         // ── Check after async autoapply step ──
//                         if (isCancelled()) {
//                             props.StopLoading();
//                             return [];
//                         }

//                         if (matchList.length === 0) continue;

//                         const preambleItem = matchList.find(i => i.styleInfo?.isPreambleInsertion);
//                         if (preambleItem) {
//                             const titleMatch = /\\title\s*\{/i.exec(temp);
//                             if (titleMatch) {
//                                 temp = preambleItem.suggestionText + temp.slice(titleMatch.index);
//                             }
//                             continue;
//                         }

//                         const captionMoveItems = matchList.filter(i => i.styleInfo?.isCaptionMove);
//                         if (captionMoveItems.length > 0) {
//                             for (const item of captionMoveItems) {
//                                 const captionText = item.styleInfo.captionText;
//                                 const ci = temp.indexOf(captionText);
//                                 if (ci === -1) continue;
//                                 const afterChar = temp[ci + captionText.length];
//                                 const removeLen = captionText.length + (afterChar === '\n' ? 1 : 0);
//                                 const afterRemoval = temp.slice(0, ci) + temp.slice(ci + removeLen);
//                                 const incPat = /\\includegraphics\s*(?:\[[^\]]*\])?\s*\{[^}]*\}/g;
//                                 incPat.lastIndex = ci;
//                                 let incMatch = incPat.exec(afterRemoval);
//                                 if (!incMatch) { incPat.lastIndex = 0; incMatch = incPat.exec(afterRemoval); }
//                                 if (!incMatch) { temp = afterRemoval; continue; }
//                                 const incEndIdx = incMatch.index + incMatch[0].length;
//                                 temp = afterRemoval.slice(0, incEndIdx) + '\n' + captionText + afterRemoval.slice(incEndIdx);
//                             }
//                             continue;
//                         }

//                         const fullLineItems = matchList.filter(i => i.styleInfo?.removeType === 'fullLine');
//                         const otherItems = matchList.filter(i => i.styleInfo?.removeType !== 'fullLine');

//                         if (fullLineItems.length > 0) {
//                             const lines = temp.split('\n');
//                             const rowsToRemove = new Set(fullLineItems.map(i => i.startAnchor.row));
//                             temp = lines.filter((_, idx) => !rowsToRemove.has(idx)).join('\n');
//                         }

//                         const sorted = [...otherItems].sort((a, b) => {
//                             if (b.startAnchor.row !== a.startAnchor.row)
//                                 return b.startAnchor.row - a.startAnchor.row;
//                             return b.startAnchor.column - a.startAnchor.column;
//                         });

//                         for (const item of sorted) {
//                             const lines = temp.split('\n');
//                             let si = 0;
//                             for (let r = 0; r < item.startAnchor.row; r++) si += (lines[r]?.length ?? 0) + 1;
//                             si += item.startAnchor.column;
//                             let ei = 0;
//                             for (let r = 0; r < item.endAnchor.row; r++) ei += (lines[r]?.length ?? 0) + 1;
//                             ei += item.endAnchor.column;
//                             const textAtPos = temp.substring(si, ei);
//                             if (textAtPos !== item.originalText) {
//                                 console.warn(`Autoapply skip: expected "${item.originalText}" but found "${textAtPos}" at row:${item.startAnchor.row} col:${item.startAnchor.column}`);
//                                 continue;
//                             }
//                             temp = temp.substring(0, si) + item.suggestionText + temp.substring(ei);
//                         }

//                     } catch (err) {
//                         console.error(`Autoapply style "${style.name}" error:`, err);
//                     }
//                 }

//                 const currentContent = session.getValue();
//                 if (currentContent !== temp) {
//                     session.markUndoGroup();
//                     const AceRange = window.ace.require('ace/range').Range;
//                     const lastRow = session.getLength() - 1;
//                     const lastCol = session.getLine(lastRow).length;
//                     const fullRange = new AceRange(0, 0, lastRow, lastCol);
//                     session.replace(fullRange, temp);
//                     session.markUndoGroup();
//                 }

//                 setTextFile(temp);
//                 props.autoapplyonoff();
//                 props.StopLoading();
//                 return [];
//             }

//             // ── Commit: spread new anchors into Redux ──
//             try {
//                 if (newAnchorList.length > 0) {
//                     props.uploadAutoSuggestions(newAnchorList);
//                 }
//             } catch (err) {
//                 console.log("Upload error:", err);
//             } finally {
//                 props.StopLoading();
//             }

//             // ── Update in-memory anchor list ──
//             // Preserve AI suggestions that are not stale
//             const aiSuggestions = existingSuggestions.filter(i => i.isAI && !allStaleIds.has(i.id));
//             const surviving = existingSuggestions.filter(i => !allStaleIds.has(i.id) && !i.isAI);

//             // Re-attach markers for AI suggestions using the STREAMLINED look (dotted underline)
//             aiSuggestions.forEach(item => {
//                 if (!item.markerId || !session.getMarkers()[item.markerId]) {
//                     const row = item.startAnchor?.row ?? 0;
//                     const col = item.startAnchor?.column ?? 0;
//                     const endRow = item.endAnchor?.row ?? row;
//                     const endCol = item.endAnchor?.column ?? col;
//                     const range = new Range(row, col, endRow, endCol);
//                     item.markerId = session.addMarker(range, "Common-highlight", "text");
//                     console.log(`Re-attached streamlined text marker for AI item: ${item.id}`);
//                 }
//             });

//             globalAnchorList = [...surviving, ...aiSuggestions, ...newAnchorList];

//             session._signal("changeBackMarker");
//             editor.renderer.updateBackMarkers();
//             editor.renderer.updateFull(true);

//             // ── Setup hover listener once, refresh props ref on subsequent runs ──
//             if (!editor.container._hoverListenerSetup) {
//                 setupHoverListener(editor, setTextFile, props);
//                 editor.container._hoverListenerSetup = true;
//             } else {
//                 if (editor.container._updatePropsRef) {
//                     editor.container._updatePropsRef(props);
//                 }
//             }

//             props.StopLoading();
//             return newAnchorList;

//         } catch (error) {
//             console.error("AutoSuggestion error:", error);
//             props.StopLoading();
//             return [];
//         }

//     } else {
//         // ── View switched away — clear everything ──
//         clearAutoSuggestions(ace);
//         props.NoSuggestions();
//         props.autoSuggestions?.forEach(item => {
//             if (item.markerId) ace.current.editor.session.removeMarker(item.markerId);
//             if (item.startAnchor?.detach) item.startAnchor.detach();
//             if (item.endAnchor?.detach) item.endAnchor.detach();
//         });
//         props.clearAutoSuggestions();
//         props.clearAutoSuggestionRejects();
//         return [];
//     }
// }





export async function AutoSuggestion(
    texFile, ace, selectedStyles = [], client,
    props, setTextFile, fileName, Allfiles,
    generation = null,
    generationRef = null
) {
    // ── isCancelled: true if a newer keystroke has fired since this run started ──
    const isCancelled = () =>
        generation !== null &&
        generationRef !== null &&
        generation !== generationRef.current;

    if (!props.showSuggestion) {
        globalPropsRef = null;
        return;
    }

    const styleRegistry = {
        epl: epl,
        edp: edp,
        common: { ...eplStyles, ...epl, ...edp },
        PeToolsStyles: PeToolsStyles,
        CeToolStyles: CeToolStyles,
    };

    globalPropsRef = props.autoSuggestions;
    props.startLoading();
    globalRejectedRef = props.autoSuggestionsRejected || [];
    console.log("the client and the styles in autosuggestion is :", client, "the styles are", selectedStyles);

    if (props.view === "suggestions") {
        if (!ace?.current) { props.StopLoading(); return null; }

        const styleSource = styleRegistry[client] || styleRegistry.common;

        activeStyles = selectedStyles
            .map(name => styleSource[name])
            .filter(Boolean);

        if (activeStyles.length === 0) {
            props.StopLoading();
            return [];
        }

        // ── Split into sync styles and async-heavy background styles ──
        const ASYNC_STYLE_NAMES = new Set(["Invalid URL or DOIs"]);
        const syncStyles = activeStyles.filter(s => !ASYNC_STYLE_NAMES.has(s.name));
        const asyncStyles = activeStyles.filter(s => ASYNC_STYLE_NAMES.has(s.name));

        try {
            const editor = ace.current.editor;
            const session = editor.session;
            const Range = window.ace.require('ace/range').Range;

            // ── Async gap: check immediately after ──
            await new Promise(r => setTimeout(r, 100));
            if (isCancelled()) {
                props.StopLoading();
                return [];
            }

            removePopup();

            const existingSuggestions = props.autoSuggestions || [];
            const rejectedSuggestions = props.autoSuggestionsRejected || [];
            const newAnchorList = [];
            const allStaleIds = new Set();

            // ── Run each SYNC style with cancellation check before AND after ──
            for (const style of syncStyles) {

                // ── CHECK BEFORE: bail before even starting this style ──
                if (isCancelled()) {
                    console.log(`AutoSuggestion cancelled before style "${style?.name}" — discarding ${newAnchorList.length} partial anchors`);
                    cancelRunCleanup(newAnchorList, session, props);
                    return [];
                }

                if (typeof style.execute !== 'function') continue;

                try {
                    const result = style.execute(
                        texFile, session, Range, newAnchorList,
                        fileName, Allfiles,
                        existingSuggestions,
                        rejectedSuggestions
                    );
                    const returned = (result instanceof Promise) ? await result : result;

                    // ── CHECK AFTER: async styles may have taken long enough for a new keystroke ──
                    if (isCancelled()) {
                        console.log(`AutoSuggestion cancelled after style "${style?.name}" — discarding ${newAnchorList.length} partial anchors`);
                        cancelRunCleanup(newAnchorList, session, props);
                        return [];
                    }

                    if (returned instanceof Set) {
                        returned.forEach(id => allStaleIds.add(id));
                    }
                } catch (err) {
                    console.error(`Style "${style.name}" error:`, err);
                }
            }

            // ── Final check before committing anything visible to the editor ──
            if (isCancelled()) {
                console.log(`AutoSuggestion cancelled before commit — discarding ${newAnchorList.length} anchors`);
                cancelRunCleanup(newAnchorList, session, props);
                return [];
            }

            // ── Find and clean up deleted/stale anchors ──
            const deletedIds = findDeletedAnchors(texFile, existingSuggestions);
            deletedIds.forEach(id => allStaleIds.add(id));
            cleanupStaleRejectedAnchors(texFile);

            if (allStaleIds.size > 0) {
                existingSuggestions
                    .filter(item => allStaleIds.has(item.id))
                    .forEach(item => cleanupAnchor(session, item));
                props.removeStaleAutoSuggestions([...allStaleIds]);
            }

            // ── Auto apply mode ──
            if (!props.showIsChecked && props.autoapply) {
                let temp = texFile;

                for (const style of syncStyles) {

                    // ── Cancellation inside autoapply loop ──
                    if (isCancelled()) {
                        props.StopLoading();
                        return [];
                    }

                    if (typeof style.execute !== 'function') continue;

                    try {
                        const matchList = [];

                        const fakeDoc = {
                            createAnchor: (row, col) => ({
                                row,
                                column: col,
                                $insertRight: false,
                                detach: () => { }
                            })
                        };
                        const fakeSession = {
                            doc: fakeDoc,
                            addMarker: () => null,
                            removeMarker: () => { },
                            getLine: (row) => temp.split('\n')[row] || ''
                        };
                        const FakeRange = function (sr, sc, er, ec) {
                            return { start: { row: sr, column: sc }, end: { row: er, column: ec } };
                        };

                        const result = style.execute(
                            temp, fakeSession, FakeRange, matchList,
                            fileName, Allfiles, [], []
                        );
                        if (result instanceof Promise) await result;

                        // ── Check after async autoapply step ──
                        if (isCancelled()) {
                            props.StopLoading();
                            return [];
                        }

                        if (matchList.length === 0) continue;

                        const preambleItem = matchList.find(i => i.styleInfo?.isPreambleInsertion);
                        if (preambleItem) {
                            const titleMatch = /\\title\s*\{/i.exec(temp);
                            if (titleMatch) {
                                temp = preambleItem.suggestionText + temp.slice(titleMatch.index);
                            }
                            continue;
                        }

                        const captionMoveItems = matchList.filter(i => i.styleInfo?.isCaptionMove);
                        if (captionMoveItems.length > 0) {
                            for (const item of captionMoveItems) {
                                const captionText = item.styleInfo.captionText;
                                const ci = temp.indexOf(captionText);
                                if (ci === -1) continue;
                                const afterChar = temp[ci + captionText.length];
                                const removeLen = captionText.length + (afterChar === '\n' ? 1 : 0);
                                const afterRemoval = temp.slice(0, ci) + temp.slice(ci + removeLen);
                                const incPat = /\\includegraphics\s*(?:\[[^\]]*\])?\s*\{[^}]*\}/g;
                                incPat.lastIndex = ci;
                                let incMatch = incPat.exec(afterRemoval);
                                if (!incMatch) { incPat.lastIndex = 0; incMatch = incPat.exec(afterRemoval); }
                                if (!incMatch) { temp = afterRemoval; continue; }
                                const incEndIdx = incMatch.index + incMatch[0].length;
                                temp = afterRemoval.slice(0, incEndIdx) + '\n' + captionText + afterRemoval.slice(incEndIdx);
                            }
                            continue;
                        }

                        const fullLineItems = matchList.filter(i => i.styleInfo?.removeType === 'fullLine');
                        const otherItems = matchList.filter(i => i.styleInfo?.removeType !== 'fullLine');

                        if (fullLineItems.length > 0) {
                            const lines = temp.split('\n');
                            const rowsToRemove = new Set(fullLineItems.map(i => i.startAnchor.row));
                            temp = lines.filter((_, idx) => !rowsToRemove.has(idx)).join('\n');
                        }

                        const sorted = [...otherItems].sort((a, b) => {
                            if (b.startAnchor.row !== a.startAnchor.row)
                                return b.startAnchor.row - a.startAnchor.row;
                            return b.startAnchor.column - a.startAnchor.column;
                        });

                        for (const item of sorted) {
                            const lines = temp.split('\n');
                            let si = 0;
                            for (let r = 0; r < item.startAnchor.row; r++) si += (lines[r]?.length ?? 0) + 1;
                            si += item.startAnchor.column;
                            let ei = 0;
                            for (let r = 0; r < item.endAnchor.row; r++) ei += (lines[r]?.length ?? 0) + 1;
                            ei += item.endAnchor.column;
                            const textAtPos = temp.substring(si, ei);
                            if (textAtPos !== item.originalText) {
                                console.warn(`Autoapply skip: expected "${item.originalText}" but found "${textAtPos}" at row:${item.startAnchor.row} col:${item.startAnchor.column}`);
                                continue;
                            }
                            temp = temp.substring(0, si) + item.suggestionText + temp.substring(ei);
                        }

                    } catch (err) {
                        console.error(`Autoapply style "${style.name}" error:`, err);
                    }
                }

                const currentContent = session.getValue();
                if (currentContent !== temp) {
                    session.markUndoGroup();
                    const AceRange = window.ace.require('ace/range').Range;
                    const lastRow = session.getLength() - 1;
                    const lastCol = session.getLine(lastRow).length;
                    const fullRange = new AceRange(0, 0, lastRow, lastCol);
                    session.replace(fullRange, temp);
                    session.markUndoGroup();
                }

                setTextFile(temp);
                props.autoapplyonoff();
                props.StopLoading();
                return [];
            }

            // ── Commit sync anchors into Redux ──
            try {
                if (newAnchorList.length > 0) {
                    props.uploadAutoSuggestions(newAnchorList);
                }
            } catch (err) {
                console.log("Upload error:", err);
            }

            // ── Update in-memory anchor list ──
            // Preserve AI suggestions that are not stale
            const aiSuggestions = existingSuggestions.filter(i => i.isAI && !allStaleIds.has(i.id));
            const surviving = existingSuggestions.filter(i => !allStaleIds.has(i.id) && !i.isAI);

            // Re-attach markers for AI suggestions using the streamlined look (dotted underline)
            aiSuggestions.forEach(item => {
                if (!item.markerId || !session.getMarkers()[item.markerId]) {
                    const row = item.startAnchor?.row ?? 0;
                    const col = item.startAnchor?.column ?? 0;
                    const endRow = item.endAnchor?.row ?? row;
                    const endCol = item.endAnchor?.column ?? col;
                    const range = new Range(row, col, endRow, endCol);
                    item.markerId = session.addMarker(range, "Common-highlight", "text");
                    console.log(`Re-attached streamlined text marker for AI item: ${item.id}`);
                }
            });

            globalAnchorList = [...surviving, ...aiSuggestions, ...newAnchorList];

            session._signal("changeBackMarker");
            editor.renderer.updateBackMarkers();
            editor.renderer.updateFull(true);

            // ── Setup hover listener once, refresh props ref on subsequent runs ──
            if (!editor.container._hoverListenerSetup) {
                setupHoverListener(editor, setTextFile, props);
                editor.container._hoverListenerSetup = true;
            } else {
                if (editor.container._updatePropsRef) {
                    editor.container._updatePropsRef(props);
                }
            }

            props.StopLoading();  // ← UI unlocks her
            // ── Fire async styles in the background — no await ──
            if (asyncStyles.length > 0) {
                const capturedGen = generation;
                const capturedGenRef = generationRef;
                const capturedExisting = [...(props.autoSuggestions || [])];
                const capturedRejected = [...(props.autoSuggestionsRejected || [])];
                const asyncAnchorList = [];

                Promise.all(
                    asyncStyles.map(style => {
                        if (typeof style.execute !== 'function') return Promise.resolve();
                        try {
                            const r = style.execute(
                                texFile, session, Range, asyncAnchorList,
                                fileName, Allfiles,
                                capturedExisting,
                                capturedRejected
                            );
                            return r instanceof Promise ? r : Promise.resolve(r);
                        } catch (err) {
                            console.error(`Async style "${style.name}" error:`, err);
                            return Promise.resolve();
                        }
                    })
                ).then(() => {
                    // ── Bail if a newer run has started since we fired ──
                    const wasCancelled =
                        capturedGen !== null &&
                        capturedGenRef !== null &&
                        capturedGen !== capturedGenRef.current;

                    if (wasCancelled) {
                        console.log(`[Background async styles] cancelled — discarding ${asyncAnchorList.length} anchors`);
                        return;
                    }

                    if (asyncAnchorList.length === 0) return;

                    // ── Append async anchors to Redux and refresh editor ──
                    try {
                        props.uploadAutoSuggestions(asyncAnchorList);
                    } catch (err) {
                        console.log("Async upload error:", err);
                    }

                    globalAnchorList = [...globalAnchorList, ...asyncAnchorList];
                    session._signal("changeBackMarker");
                    editor.renderer.updateBackMarkers();
                    editor.renderer.updateFull(true);
                    console.log(`[Background async styles] appended ${asyncAnchorList.length} anchors`);

                }).catch(err => console.error("Background async styles fatal error:", err));
            }

            return newAnchorList;

        } catch (error) {
            console.error("AutoSuggestion error:", error);
            props.StopLoading();
            return [];
        }

    } else {
        // ── View switched away — clear everything ──
        clearAutoSuggestions(ace);
        props.NoSuggestions();
        props.autoSuggestions?.forEach(item => {
            if (item.markerId) ace.current.editor.session.removeMarker(item.markerId);
            if (item.startAnchor?.detach) item.startAnchor.detach();
            if (item.endAnchor?.detach) item.endAnchor.detach();
        });
        props.clearAutoSuggestions();
        props.clearAutoSuggestionRejects();
        return [];
    }
}

function setupHoverListener(editor, setTextFile, props) {
    const container = editor.container;
    let currentPopup = null;
    let currentHoveredItem = null;
    let isMouseOverPopup = false;
    let hidePopupTimeout = null;
    let showPopupTimeout = null;
    let propsRef = props;
    container._updatePropsRef = (newProps) => { propsRef = newProps; };

    const hoverListener = (e) => {
        // ── Bail out if hovering over the Ace search/find box ──
        const searchBox = editor.container.querySelector('.ace_search');
        if (searchBox && searchBox.contains(e.target)) return;

        if (hidePopupTimeout) { clearTimeout(hidePopupTimeout); hidePopupTimeout = null; }
        if (isMouseOverPopup) return;

        const position = editor.renderer.screenToTextCoordinates(e.clientX, e.clientY);
        const hoveredItem = findHoveredItem(position);

        if (hoveredItem) {
            const startRow = hoveredItem.startAnchor.row;
            const endRow = hoveredItem.endAnchor.row;
            const startCol = hoveredItem.startAnchor.column;
            const endCol = hoveredItem.endAnchor.column;

            let isOverActualText;
            if (startRow === endRow) {
                isOverActualText = position.column >= startCol && position.column < endCol;
            } else {
                if (position.row === startRow) {
                    isOverActualText = position.column >= startCol;
                } else if (position.row === endRow) {
                    isOverActualText = endCol === 0 ? true : position.column < endCol;
                } else {
                    isOverActualText = true;
                }
            }

            if (isOverActualText) {
                if (hoveredItem !== currentHoveredItem) {
                    if (showPopupTimeout) { clearTimeout(showPopupTimeout); showPopupTimeout = null; }
                    if (currentPopup) { removePopup(); currentPopup = null; }

                    currentHoveredItem = hoveredItem;

                    showPopupTimeout = setTimeout(() => {
                        if (currentHoveredItem === hoveredItem) {
                            currentPopup = showPopup(
                                e, editor, hoveredItem, setTextFile,
                                () => { isMouseOverPopup = false; currentHoveredItem = null; },
                                (value) => { isMouseOverPopup = value; },
                                propsRef
                            );
                        }
                    }, 1000);
                }
            }
        } else if (currentHoveredItem && !isMouseOverPopup) {
            if (showPopupTimeout) { clearTimeout(showPopupTimeout); showPopupTimeout = null; }
            hidePopupTimeout = setTimeout(() => {
                if (!isMouseOverPopup) {
                    currentHoveredItem = null;
                    removePopup();
                    currentPopup = null;
                }
            }, 150);
        }
    };
    // ── Close popup on any keypress in the editor ──
    const keydownListener = () => {
        if (showPopupTimeout) { clearTimeout(showPopupTimeout); showPopupTimeout = null; }
        currentHoveredItem = null;
        isMouseOverPopup = false;
        removePopup();
        currentPopup = null;
    };

    // editor.on('keydown', keydownListener);
    // container._keydownListener = keydownListener;

    const mouseLeaveListener = (e) => {
        if (showPopupTimeout) { clearTimeout(showPopupTimeout); showPopupTimeout = null; }
        if (hidePopupTimeout) { clearTimeout(hidePopupTimeout); hidePopupTimeout = null; }
        if (!isMouseOverPopup) {
            currentHoveredItem = null;
            removePopup();
            currentPopup = null;
        }
    };

    const globalMouseMoveListener = (e) => {
        const editorRect = container.getBoundingClientRect();
        const isOutside =
            e.clientX < editorRect.left ||
            e.clientX > editorRect.right ||
            e.clientY < editorRect.top ||
            e.clientY > editorRect.bottom;

        if (isOutside && !isMouseOverPopup) {
            if (showPopupTimeout) { clearTimeout(showPopupTimeout); showPopupTimeout = null; }
            if (currentHoveredItem) {
                currentHoveredItem = null;
                removePopup();
                currentPopup = null;
            }
        }
    };

    container.addEventListener('mousemove', hoverListener);
    container.addEventListener('mouseleave', mouseLeaveListener);
    document.addEventListener('mousemove', globalMouseMoveListener);
    container.addEventListener('keydown', keydownListener);

    container._hoverListener = hoverListener;
    container._mouseLeaveListener = mouseLeaveListener;
    container._globalMouseMoveListener = globalMouseMoveListener;
    container._keydownListener = keydownListener;
}

function findHoveredItem(position) {
    const rejectedIds = new Set(globalRejectedAnchorList.map(r => r.id));
    const activeSuggestions = globalAnchorList.filter(item => !rejectedIds.has(item.id));

    const matches = activeSuggestions.filter(item => {
        if (item.queryOnly) return false;
        const startRow = item.startAnchor.row;
        const startCol = item.startAnchor.column;
        const endRow = item.endAnchor.row;
        const endCol = item.endAnchor.column;

        if (position.row < startRow || position.row > endRow) return false;

        if (startRow === endRow) {
            return position.column >= startCol && position.column <= endCol;
        }
        if (position.row === startRow) return position.column >= startCol;
        if (position.row === endRow) {
            return endCol > 0 && position.column <= endCol;
        }
        return true;
    });

    if (matches.length === 0) return null;
    if (matches.length === 1) return matches[0];

    // ── Pick the smallest (most specific/innermost) anchor ──
    return matches.reduce((best, item) => {
        const itemSize = getAnchorSize(item);
        const bestSize = getAnchorSize(best);
        return itemSize < bestSize ? item : best;
    });
}

function getAnchorSize(item) {
    const startRow = item.startAnchor.row;
    const startCol = item.startAnchor.column;
    const endRow = item.endAnchor.row;
    const endCol = item.endAnchor.column;

    if (startRow === endRow) return endCol - startCol;
    return (endRow - startRow) * 10000 + endCol - startCol;
}

function showPopup(mouseEvent, editor, item, setTextFile, onPopupClose, setMouseOverPopup, props) {
    removePopup();

    const popupContainer = document.createElement('div');
    popupContainer.className = 'ace-suggestion-popup-container';
    popupContainer.id = 'ace-suggestion-popup';

    const popup = createAutoSuggestionPopup(
        item,
        () => {
            acceptSuggestion(editor, item, setTextFile, props);
            handleClose(popupContainer, null, setMouseOverPopup, onPopupClose);
        },
        () => {
            rejectSuggestion(item, props, editor);
            handleClose(popupContainer, null, setMouseOverPopup, onPopupClose);
        },
        () => {
            handleClose(popupContainer, null, setMouseOverPopup, onPopupClose);
        }
    );

    popupContainer.appendChild(popup);

    // ── Render off-screen first so React can paint before we measure ──
    popupContainer.style.cssText = `
        visibility: hidden;
        position: absolute;
        top: -9999px;
        left: -9999px;
        z-index: 1000;
    `;
    editor.container.appendChild(popupContainer);

    popupContainer.addEventListener('mouseenter', () => setMouseOverPopup(true));
    popupContainer.addEventListener('mouseleave', () => {
        setMouseOverPopup(false);
        setTimeout(() => {
            handleClose(popupContainer, null, setMouseOverPopup, onPopupClose);
        }, 300);
    });

    // ── Wait for React (PopupDiff) to finish rendering before measuring ──
    setTimeout(() => {
        requestAnimationFrame(() => {
            // Bail if popup was closed while we were waiting
            if (!popupContainer.parentNode) return;

            const popupHeight = popupContainer.offsetHeight;
            const popupWidth = popupContainer.offsetWidth;

            const renderer = editor.renderer;
            const editorRect = editor.container.getBoundingClientRect();
            const lineHeight = renderer.lineHeight;
            const editorWidth = editorRect.width;
            const editorHeight = editorRect.height;
            const padding = 0;

            const mouseXInEditor = mouseEvent.clientX - editorRect.left;

            const { row } = item.startAnchor;
            const lineScreenPos = renderer.textToScreenCoordinates(row, item.startAnchor.column);
            const lineTop = lineScreenPos.pageY - editorRect.top;
            const lineBottom = lineTop + lineHeight;

            // ── Vertical placement ──
            let top, placement;
            if (lineTop > popupHeight + padding) {
                top = lineTop - popupHeight - padding;
                placement = "ABOVE";
            } else if (editorHeight - lineBottom > popupHeight + padding) {
                top = lineBottom + padding;
                placement = "BELOW";
            } else if (lineTop > editorHeight - lineBottom) {
                top = Math.max(padding, lineTop - popupHeight - padding);
                placement = "ABOVE-CLAMPED";
            } else {
                top = Math.min(editorHeight - popupHeight - padding, lineBottom + padding);
                placement = "BELOW-CLAMPED";
            }

            // ── Horizontal placement ──
            let left;
            const halfPopup = popupWidth / 2;
            const centeredLeft = mouseXInEditor - halfPopup;
            const spaceRight = editorWidth - mouseXInEditor;
            const spaceLeft = mouseXInEditor;

            if (centeredLeft >= padding && centeredLeft + popupWidth <= editorWidth - padding) {
                left = centeredLeft;
                placement += "-CENTER";
            } else if (spaceRight >= popupWidth + padding) {
                left = mouseXInEditor;
                placement += "-RIGHT";
            } else if (spaceLeft >= popupWidth + padding) {
                left = mouseXInEditor - popupWidth;
                placement += "-LEFT";
            } else if (spaceRight > spaceLeft) {
                left = Math.min(mouseXInEditor, editorWidth - popupWidth - padding);
                placement += "-RIGHT-CLAMPED";
            } else {
                left = Math.max(padding, mouseXInEditor - popupWidth);
                placement += "-LEFT-CLAMPED";
            }

            top = Math.max(padding, Math.min(top, editorHeight - popupHeight - padding));
            left = Math.max(padding, Math.min(left, editorWidth - popupWidth - padding));

            popupContainer.style.top = `${top}px`;
            popupContainer.style.left = `${left}px`;
            popupContainer.style.visibility = 'visible';

            if (placement.includes("ABOVE")) {
                popupContainer.classList.add('popup-above');
                popupContainer.classList.remove('popup-below');
            } else {
                popupContainer.classList.add('popup-below');
                popupContainer.classList.remove('popup-above');
            }
        });
    }, 0);   // ← one tick lets React flush its render
}



function createAutoSuggestionPopup(item, onAccept, onReject, onClose) {
    const popup = document.createElement('div');
    popup.className = 'ace-suggestion-popup';
    popup.addEventListener('wheel', (e) => e.stopPropagation(), { passive: true });
    popup.style.height = 'auto';
    popup.style.maxHeight = '500px';
    popup.style.paddingBottom = '50px';

    // ── Close button (unchanged) ──────────────────────────────────────────────
    const closeBtn = document.createElement('button');
    closeBtn.className = 'popup-close-btn';
    closeBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>  
    </svg>`;
    closeBtn.addEventListener('click', onClose);
    popup.appendChild(closeBtn);

    // ── Header (unchanged) ────────────────────────────────────────────────────
    const header = document.createElement('div');
    header.className = 'popup-header';
    const headerText = document.createElement('span');
    headerText.className = 'popup-header-text';
    headerText.textContent = item.styleInfo.description;

    header.appendChild(headerText);
    header.setAttribute('data-title', item.styleInfo.description);
    popup.appendChild(header);

    // ── PopupDiff mount point ─────────────────────────────────────────────────
    // Replaces the old: originalBlock + arrow + suggestionBlock
    // The PopupDiff component renders the same two-box layout but with
    // character-level diff highlights inside each box.
    const diffMount = document.createElement('div');
    diffMount.className = 'popup-diff-mount';
    // diffMount.style.minHeight = '220px'
    diffMount.style.height = 'auto';
    diffMount.style.maxHeight = '250px'
    popup.appendChild(diffMount);

    const root = createRoot(diffMount);
    root.render(
        React.createElement(PopupDiff, {
            oldText: item.originalText ?? '',
            newText: item.suggestionText ?? '',
        })
    );

    // Store root on the popup so handleClose can unmount it cleanly
    popup._reactRoot = root;

    // ── Action buttons (unchanged) ────────────────────────────────────────────
    const actions = document.createElement('div');
    actions.className = 'popup-actions';
    actions.style.position = 'absolute';
    actions.style.bottom = '0'
    actions.style.display = 'flex'
    actions.style.width = '100%'
    actions.style.background = 'white'

    const acceptBtn = document.createElement('button');
    acceptBtn.className = 'popup-btn accept';
    acceptBtn.innerHTML = `<svg width="13" height="13" viewBox="0 0 16 16" fill="none">
        <path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg> Accept`;
    acceptBtn.addEventListener('click', onAccept);

    const rejectBtn = document.createElement('button');
    rejectBtn.className = 'popup-btn reject';
    rejectBtn.innerHTML = `<svg width="13" height="13" viewBox="0 0 16 16" fill="none">
        <path d="M12 4L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg> Ignore`;
    rejectBtn.addEventListener('click', onReject);

    actions.appendChild(acceptBtn);
    actions.appendChild(rejectBtn);
    popup.appendChild(actions);

    return popup;
}

// function handleClose(container, root, setMouseOverPopup, onPopupClose) {
//     if (document.getElementById('ace-suggestion-popup') === container) {
//         setMouseOverPopup(false);
//         // Unmount the React tree before removing DOM node
//         container._reactRoot?.unmount();
//         container.remove();
//         if (onPopupClose) onPopupClose();
//     }
// }

// function handleClose(container, root, setMouseOverPopup, onPopupClose) {
//     if (document.getElementById('ace-suggestion-popup') === container) {
//         setMouseOverPopup(false);
//         container.remove();
//         if (onPopupClose) onPopupClose();
//     }
// }
function handleClose(container, root, setMouseOverPopup, onPopupClose) {
    if (document.getElementById('ace-suggestion-popup') === container) {
        setMouseOverPopup(false);

        // Unmount React root before removing the DOM node
        // This prevents "Cannot update an unmounted root" React warnings
        const popup = container.querySelector('.ace-suggestion-popup');
        if (popup?._reactRoot) {
            // React requires unmount to be async-safe — defer by one tick
            setTimeout(() => popup._reactRoot.unmount(), 0);
        }

        container.remove();
        if (onPopupClose) onPopupClose();
    }
}

function clearPreviousMarkers(ace) {
    if (!ace?.current || globalAnchorList.length === 0) return;
    const session = ace.current.editor.session;
    globalAnchorList?.forEach(item => {
        if (item.markerId) session.removeMarker(item.markerId);
        if (item.startAnchor?.detach) item.startAnchor.detach();
        if (item.endAnchor?.detach) item.endAnchor.detach();
    });
    globalAnchorList = [];
}

function cleanupStaleRejectedAnchors(texFile) {
    const lines = texFile.split('\n');
    const toDetach = [];

    globalRejectedAnchorList = globalRejectedAnchorList.filter(item => {
        const row = item.startAnchor.row;
        const col = item.startAnchor.column;
        const line = lines[row];

        if (line === undefined) { toDetach.push(item); return false; }

        const textAtPos = line.substring(col, col + item.originalText.length);
        if (textAtPos !== item.originalText) { toDetach.push(item); return false; }

        return true;
    });

    toDetach.forEach(item => {
        if (item.startAnchor?.detach) item.startAnchor.detach();
    });
}

export function clearAutoSuggestions(ace) {
    if (!ace?.current) return;
    const session = ace.current.editor.session;
    const container = ace.current.editor.container;
    if (container._keydownListener) {
        ace.current.editor.off('keydown', container._keydownListener);
        // container.removeEventListener('keydown', container._keydownListener);
        delete container._keydownListener;
    }

    if (container._hoverListener) {
        container.removeEventListener('mousemove', container._hoverListener);
        delete container._hoverListener;
    }
    if (container._mouseLeaveListener) {
        container.removeEventListener('mouseleave', container._mouseLeaveListener);
        delete container._mouseLeaveListener;
    }
    if (container._globalMouseMoveListener) {
        document.removeEventListener('mousemove', container._globalMouseMoveListener);
        delete container._globalMouseMoveListener;
    }
    delete container._hoverListenerSetup;

    removePopup();

    globalAnchorList.forEach(item => {
        if (item.markerId) session.removeMarker(item.markerId);
        if (item.startAnchor?.detach) item.startAnchor.detach();
        if (item.endAnchor?.detach) item.endAnchor.detach();
    });
    globalRejectedAnchorList.forEach(item => {
        if (item.startAnchor?.detach) item.startAnchor.detach();
    });
    globalAnchorList = [];
    activeStyles = [];
    globalRejectedAnchorList = [];
    globalRejectedRef = null;
    globalRejectedIds = new Set();
    globalRejectedPositions = [];
    globalRejectedKeys = new Set();
}

export const forceClearAll = (editor) => {
    globalAnchorList.forEach(item => {
        if (item.markerId) editor.session.removeMarker(item.markerId);
    });
    globalAnchorList = []; // Clear the internal tracking list
    editor.session._signal("changeBackMarker");
};

export function getAvailableStyles() {
    return Object.keys(eplStyles).map(key => ({
        id: key,
        name: eplStyles[key].name,
        description: eplStyles[key].description
    }));
}